"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = useStaticElementEntries;

var _useContext = _interopRequireDefault(require("./useContext"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function useStaticElementEntries() {
  return (0, _useContext.default)().staticElementEntriesState;
}
//# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJuYW1lcyI6WyJ1c2VTdGF0aWNFbGVtZW50RW50cmllcyIsInVzZUxpdmVSZWdpb25Ud2luQ29udGV4dCIsInN0YXRpY0VsZW1lbnRFbnRyaWVzU3RhdGUiXSwic291cmNlUm9vdCI6ImNvbXBvbmVudDovLy8iLCJzb3VyY2VzIjpbIi4uLy4uLy4uLy4uL3NyYy9wcm92aWRlcnMvTGl2ZVJlZ2lvblR3aW4vcHJpdmF0ZS91c2VTdGF0aWNFbGVtZW50RW50cmllcy50cyJdLCJzb3VyY2VzQ29udGVudCI6WyJpbXBvcnQgdXNlTGl2ZVJlZ2lvblR3aW5Db250ZXh0IGZyb20gJy4vdXNlQ29udGV4dCc7XG5cbmltcG9ydCB0eXBlIHsgU3RhdGljRWxlbWVudEVudHJ5IH0gZnJvbSAnLi90eXBlcyc7XG5cbmV4cG9ydCBkZWZhdWx0IGZ1bmN0aW9uIHVzZVN0YXRpY0VsZW1lbnRFbnRyaWVzKCk6IHJlYWRvbmx5IFtyZWFkb25seSBTdGF0aWNFbGVtZW50RW50cnlbXV0ge1xuICByZXR1cm4gdXNlTGl2ZVJlZ2lvblR3aW5Db250ZXh0KCkuc3RhdGljRWxlbWVudEVudHJpZXNTdGF0ZTtcbn1cbiJdLCJtYXBwaW5ncyI6Ijs7Ozs7OztBQUFBOzs7O0FBSWUsU0FBU0EsdUJBQVQsR0FBNkU7RUFDMUYsT0FBTyxJQUFBQyxtQkFBQSxJQUEyQkMseUJBQWxDO0FBQ0QifQ==